import { createSelector } from 'reselect';
export const featureTogglesRootSelector = state => state.featureToggles;
export const featureTogglesSelector = createSelector(featureTogglesRootSelector, ({
  toggles
}) => toggles);
export const isResellerApprovalFlowFeatureEnabledSelector = createSelector(featureTogglesSelector, toggles => toggles.resellerApprovalFlow);
export const faqSwagSpacePageOnInventoryFeatureEnabledSelector = createSelector(featureTogglesSelector, ({
  faqSwagSpacePageOnInventory
}) => faqSwagSpacePageOnInventory);
export const isResellerPdfPresentationFlowFeatureEnabledSelector = createSelector(featureTogglesSelector, toggles => toggles.resellerPdfPresentation);
export const autoReplenishInventoryFeatureEnabledSelector = createSelector(featureTogglesSelector, ({
  autoReplenishInventory
}) => autoReplenishInventory);
export const isResellerBonusCommissionFeatureEnabledSelector = createSelector(featureTogglesSelector, ({
  resellerBonusCommission
}) => resellerBonusCommission);
export const isLoginAsResellerFeatureEnabledSelector = createSelector(featureTogglesSelector, ({
  loginAsReseller
}) => loginAsReseller);